import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { RustyRoyalCoin } from "../../utils/SvgIcons";

const PriceUpdatePopup = ({
  title,
  onCloseModal,
  open,
  currentProduct,
  setDummy,
}) => {
  const [price, setPrice] = useState("");
  const [error, setError] = useState("");
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setPrice(value);
      setError("");
    } else {
      setError("Invalid input. Please enter a valid number.");
    }
  };

  const handleConfirm = async () => {
    setDummy(false);
    if (!price || price <= 0) {
      setError("Price must be greater than 0.");
      return;
    }
    console.log("Price:", price, currentProduct?._id);
    const response = await adminInstance().put(
      `api/admin/updateProductPrice/${currentProduct?._id}`,
      {
        price: price,
      }
    );
    const { code } = response.data;
    if (code === 200) {
      setDummy(true);
      toast.success("Price Updated Successfully");
    } else {
      setDummy(false);
    }
    setPrice("");
    setError("");
    onCloseModal();
  };
  return (
    <Modal
      isOpen={open}
      toggle={onCloseModal}
      style={{
        maxWidth: "400px",
        margin: "auto",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
      }}
    >
      <ModalHeader
        toggle={onCloseModal}
        style={{
          backgroundColor: "#f5f5f5",
          color: "#000 !important",
          fontWeight: "bold",
          borderBottom: "1px solid #ddd",
          textAlign: "center",
        }}
      >
        {title}
      </ModalHeader>
      <ModalBody style={{ textAlign: "center", padding: "20px" }}>
        <p style={{ marginBottom: "15px", fontSize: "16px", color: "#555" }}>
          Product Name:{" "}
          <span style={{ fontWeight: "bold", color: "#333" }}>
            {currentProduct?.name}
          </span>
        </p>
        <p style={{ marginBottom: "15px", fontSize: "16px", color: "#555" }}>
          Current Amount:{" "}
          <span
            className="d-flex justify-content-center m-0"
            style={{ fontWeight: "bold", color: "#333" }}
          >
            <RustyRoyalCoin size={16} />{" "}
            <div className="pl-1">{currentProduct?.price}</div>
          </span>
        </p>
        <p style={{ marginBottom: "15px", fontSize: "16px", color: "#555" }}>
          Enter the new price:
        </p>
        <input
          type="number"
          value={price}
          onChange={handleInputChange}
          placeholder="Enter price"
          style={{
            width: "80%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "16px",
          }}
        />
        {error && (
          <p style={{ color: "red", fontSize: "14px", marginTop: "10px" }}>
            {error}
          </p>
        )}
      </ModalBody>
      <ModalFooter style={{ justifyContent: "space-between" }}>
        <Button
          type="button"
          onClick={handleConfirm}
          style={{
            backgroundColor: "#ff4d53",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Confirm
        </Button>
        <Button
          type="button"
          onClick={onCloseModal}
          style={{
            backgroundColor: "#6c757d",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PriceUpdatePopup;
